/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const BuildingIcon = ({ width = 24, height = 24, hidden = false, title = 'Building' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <circle cx="12" cy="5" r="1" fill="currentColor" />
    <circle cx="8" cy="8.00019" r="1" fill="currentColor" />
    <circle cx="8" cy="5" r="1" fill="currentColor" />
    <circle cx="12" cy="8.00019" r="1" fill="currentColor" />
    <path
      d="M14.75,1H5.25c-1.24023,0-2.25,1.00977-2.25,2.25v12.5c0,1.24023,1.00977,2.25,2.25,2.25h9.5c1.24023,0,2.25-1.00977,2.25-2.25V3.25c0-1.24023-1.00977-2.25-2.25-2.25ZM11.49902,16.5h-2.49902v-3.25c0-.41309.33691-.75.75-.75h.99902c.41309,0,.75.33691.75.75v3.25ZM15.5,15.75c0,.41309-.33691.75-.75.75h-1.75098v-3.25c0-1.24023-1.00977-2.25-2.25-2.25h-.99902c-1.24023,0-2.25,1.00977-2.25,2.25v3.25h-2.25c-.41309,0-.75-.33691-.75-.75V3.25c0-.41309.33691-.75.75-.75h9.5c.41309,0,.75.33691.75.75v12.5Z"
      fill="currentColor"
    />
  </svg>`;
};
